import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TemplateDesignElement } from '../../design-element';
import {
  CommunicationTemplate,
  CommunicationTemplateViewControl,
  MassNotificationTemplate,
  MessageSettings,
  TemplateViewControlType
} from 'src/app/modules/communications/store/communications';

@Component({
    selector: 'topo-template-attachments-element',
    templateUrl: './attachments-control.component.html',
    styleUrls: ['./attachments-control.component.scss'],
    standalone: false
})
export class TemplateDesignAttachmentsElement implements OnInit, OnDestroy, TemplateDesignElement {
  @Input() index: number;
  @Input() messageSettings?: MessageSettings;
  @Input() template?: CommunicationTemplate;
  @Input() control?: CommunicationTemplateViewControl;
  @Input() culture: string;
  @Input() orgLanguages: string[];
  @Input() selected: boolean;
  @Output() settingsChanged = new EventEmitter<{ uId: string; settings: any }>();

  editMode: boolean;
  controlDisplay: string;

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  loadSettings(): void {
    this.editMode = true;
  }
  saveSettings(): boolean {
    return true;
  }
  render(): void {
    this.editMode = false;
    this.controlDisplay = this.translateService.instant('COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Attachments);
  }
  edit(): void {}
  setRuntimeData(data: any): void {}
}
